import axios from "axios";
import Api from "../Api/Api.json";
import React, { useState, useEffect } from "react";
import { Link, Route, Routes } from "react-router-dom";
import {
	Card,
	CardContent,
	Typography,
	Button,
	Box,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Divider,
	Container,
	Paper,
} from "@mui/material";
import {
	CreditCard,
	CheckCircle,
	Email,
	Refresh,
	AttachMoney,
} from "@mui/icons-material";

const SubscriptionPlan = () => {
	return (
		<Container maxWidth="md" className="py-8">
			<Paper elevation={3} className="rounded-lg overflow-hidden">
				<Box className="bg-gradient-to-r from-blue-500 to-purple-600 p-6 text-white">
					<Typography variant="h4" className="font-bold text-center">
						Magicverse Credits
					</Typography>
					<Typography
						variant="subtitle1"
						className="text-center mt-2"
					>
						Purchase credits to create amazing videos
					</Typography>
				</Box>

				<CardContent className="p-6 bg-white">
					<Box className="flex flex-col items-center mb-6">
						<Button
							variant="contained"
							color="primary"
							size="large"
							href="https://buy.stripe.com/cN2bLu6410iJ77O3cd"
							target="_blank"
							className="font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all"
							startIcon={<CreditCard />}
						>
							Buy Magicverse Credits
						</Button>
					</Box>

					<Divider className="my-4" />

					<Box className="mt-6">
						<Typography
							variant="h6"
							className="font-bold mb-3 flex items-center"
						>
							<AttachMoney className="mr-2" /> Pricing
						</Typography>
						<List className="pl-4">
							<ListItem className="pl-0">
								<ListItemIcon className="min-w-0 mr-2">
									<CheckCircle
										color="primary"
										fontSize="small"
									/>
								</ListItemIcon>
								<ListItemText primary="You get 10 video minutes per dollar." />
							</ListItem>

							<ListItem className="pl-0">
								<ListItemIcon className="min-w-0 mr-2">
									<CheckCircle
										color="primary"
										fontSize="small"
									/>
								</ListItemIcon>
								<ListItemText primary="So buying $10 will give you 100 video minutes." />
							</ListItem>

							<ListItem className="pl-0">
								<ListItemIcon className="min-w-0 mr-2">
									<CheckCircle
										color="primary"
										fontSize="small"
									/>
								</ListItemIcon>
								<ListItemText primary="For additional video minutes, simply increase the number of products during checkout." />
							</ListItem>
						</List>
					</Box>

					<Box className="mt-6">
						<Typography
							variant="h6"
							className="font-bold mb-3 flex items-center"
						>
							<CreditCard className="mr-2" /> Payment Method
						</Typography>
						<List className="pl-4">
							<ListItem className="pl-0">
								<ListItemIcon className="min-w-0 mr-2">
									<CheckCircle
										color="primary"
										fontSize="small"
									/>
								</ListItemIcon>
								<ListItemText primary="Buy video creation credit through Stripe checkout." />
							</ListItem>

							<ListItem className="pl-0">
								<ListItemIcon className="min-w-0 mr-2">
									<CheckCircle
										color="primary"
										fontSize="small"
									/>
								</ListItemIcon>
								<ListItemText primary="Use the same email for payment as used in Magicverse login." />
							</ListItem>

							<ListItem className="pl-0">
								<ListItemIcon className="min-w-0 mr-2">
									<CheckCircle
										color="primary"
										fontSize="small"
									/>
								</ListItemIcon>
								<ListItemText primary="Reload dashboard to check your updated quota after the payment." />
							</ListItem>
						</List>
					</Box>
				</CardContent>
			</Paper>
		</Container>
	);
};

export default SubscriptionPlan;
